import {action, observable} from 'mobx';
import objectAssignDeep from 'utils/object-assign-deep';

import APIRequestState from './_util/api-request';

class SubmitVerificationState extends APIRequestState {
  putRequest(userId, ...params) {
    return this.ctx.sdk.post(`/users/${userId}/verify`, ...params);
  }
}

class RefreshVerificationTokenState extends APIRequestState {
  putRequest(userId, ...params) {
    return this.ctx.sdk.post(`/users/${userId}/verify-refresh`, ...params);
  }
}

class VerifyAccountState {
  @observable _refreshToken;
  @observable _submitToken;

  refreshToken(...args) {
    if (!this._refreshToken) this._refreshToken = new RefreshVerificationTokenState(this.ctx);
    return this._refreshToken.put(...args);
  }

  submitToken(...args) {
    if (!this._submitToken) this._submitToken = new SubmitVerificationState(this.ctx);
    return this._submitToken.put(...args);
  }

  reset() {
    if (this._refreshToken) this._refreshToken.reset();
    if (this._submitToken) this._submitToken.reset();
  }

  abort() {
    if (this._refreshToken) {
      this._refreshToken.abort();
    }
    if (this._submitToken) {
      this._submitToken.abort();
    }
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  @action('deserialize - EmployeeState')
  deserialize(value) {
    const {
      _refreshToken,
      _submitToken,
      ...rest
    } = value;
    objectAssignDeep(this, rest);
    if (_refreshToken) {
      this._refreshToken = new RefreshVerificationTokenState(this.ctx);
      objectAssignDeep(this._refreshToken, _refreshToken);
    }
    if (_submitToken) {
      this._submitToken = new SubmitVerificationState(this.ctx);
      objectAssignDeep(this._submitToken, _submitToken);
    }
  }
}

export default VerifyAccountState;



// WEBPACK FOOTER //
// ./spa/state/verify-account.jsx